
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#icon-calendar_svg__clip0_1602_11668)","fill":"#000"}},[_c('path',{attrs:{"d":"M20.538 23.076H3.462a2.54 2.54 0 01-2.539-2.538V5.307a2.54 2.54 0 012.539-2.538h17.076a2.54 2.54 0 012.539 2.538v15.23a2.54 2.54 0 01-2.539 2.54zM3.462 4.153c-.636 0-1.154.518-1.154 1.154v15.23c0 .637.518 1.155 1.154 1.155h17.076c.636 0 1.154-.518 1.154-1.154V5.307c0-.636-.518-1.154-1.154-1.154H3.462z"}}),_c('path',{attrs:{"d":"M22.385 9.691H1.615a.693.693 0 010-1.384h20.77a.693.693 0 010 1.384z"}}),_c('path',{attrs:{"d":"M6.23 6.46a.693.693 0 01-.691-.692V1.614a.693.693 0 011.384 0v4.154c0 .382-.31.692-.692.692z"}}),_c('path',{attrs:{"d":"M17.77 6.46a.693.693 0 01-.693-.692V1.614a.693.693 0 011.384 0v4.154c0 .382-.31.692-.692.692z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"icon-calendar_svg__clip0_1602_11668"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 -.001)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    